import { render } from "./RecuperarContrasenna.vue?vue&type=template&id=5fd4f956"
import script from "./RecuperarContrasenna.vue?vue&type=script&lang=js"
export * from "./RecuperarContrasenna.vue?vue&type=script&lang=js"

import "./RecuperarContrasenna.vue?vue&type=style&index=0&id=5fd4f956&lang=css"

import exportComponent from "C:\\Users\\Desarrollo\\Documents\\Inventarios 2.0\\Technosoft.Inventarios.v2\\Technosoft.Inventarios.v2.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__